import React, { useState } from 'react';
import './Dashboard.css';
import Header from '../landing/Header';
import { useNavigate } from 'react-router-dom';
import Curtain from '../components/Curtain'; // Import the Curtain component

// Import SVG icons
import conversationIcon from './icons/conversation.svg';
import personIcon from './icons/exercise1-blue-person.svg';
import silverShieldIcon from './icons/silvershield.svg';
import starMascotIcon from './icons/Star Mascot.svg';

const Dashboard = () => {
  const navigate = useNavigate();
  const [isCurtainVisible, setIsCurtainVisible] = useState(false); // State for curtain visibility
  const duration = 2000; // Duration for curtain animation in ms (2 seconds)

  // Handle person icon click to show the curtain and navigate after duration
  const handlePersonIconClick = () => {
    setIsCurtainVisible(true); // Show the curtain

    // Wait for the curtain to fully appear, then navigate to the exercise page
    setTimeout(() => {
      navigate('/exercise1'); // Navigate to /exercise1 after 2 seconds (curtain duration)
    }, duration);
  };

  return (
    <div className="dashboard-page">
      <Header />

      {/* Render the curtain only when isCurtainVisible is true */}
      {isCurtainVisible && <Curtain appear duration={duration} />}

      <div className="dashboard-main">
        <div className="goal-of-the-day">
          <img src={silverShieldIcon} alt="Goal Icon" className="goal-icon" />
          <div className="goal-text">
            <p>Goal of the Day</p>
            <strong>Rhythmic Breathing (Exercise 1)</strong>
          </div>
        </div>

        <div className="meditation-seat">
          <img
            className="meditation-icon"
            src={personIcon}
            alt="Meditation Icon"
            onClick={handlePersonIconClick}
            style={{ cursor: 'pointer' }}
          />
        </div>

          {/* Button appears after the last section */}
          <button 
            className="dashboardButton"
            onClick={handlePersonIconClick}  // Add navigation handler here
          >
            Start!
          </button>
        
        {/* <div className="ask-mascot">
          <div className="conversation-container">
            <img src={conversationIcon} alt="Conversation Icon" className="conversation-icon" />
            <p className="ask-text">Ask me anything</p>
          </div>

          <div className="mascot-icon">
            <img src={starMascotIcon} alt="Mascot Icon" />
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Dashboard;
